import {SwiperComponent} from "./Swiper";
import {createLogger} from "../util/logger";

const console = createLogger("FrontPageSwiper");


export class FrontPageSwiper extends SwiperComponent {
    static name = "front-page-swiper";

    get name() {
        return FrontPageSwiper.name;
    }

    get options() {
        return {
            ...super.options,
            slidesPerView: 1,
            loop: true,
            breakpoints: {
                480: {
                    slidesPerView: 1.1,
                },
                1024: {
                    slidesPerView: 2,
                }
            },
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            on: {
                slideChangeTransitionStart: this.onSlideTransitionStart.bind(this),
                slideChangeTransitionEnd: this.onSlideTransitionEnd.bind(this),
                transitionStart: this.onTransitionStart.bind(this),
                transitionEnd: this.onTransitionEnd.bind(this),
            }
        }
    }

    constructor(el) {
        super(el);

        console.log("option", this.options);

        /**
         *
         * @type {HTMLElement}
         */
        this.$textOverlay = this.$("textOverlay");

        /**
         *
         * @type {HTMLElement[]}
         */
        this.$swiperContent = this.$("swiperContent");

        this.$emptySwipe = this.$("emptySwipe");

        this.updateText(this.$swiperContent[this.swiper.activeIndex]);

        this.addEventListener(window, "resize", this.onResize.bind(this));

        console.log(this);
        this.onResize();
    }

    onResize() {
        return;

        const index = this.swiper.slides.findIndex((el) => el.matches(this.getAttributeSelector("emptySwipe")));

        const is_mobile = window.innerWidth < 1024;

        if (is_mobile && index >= 0) {
            console.log("removeSlide", {index, is_mobile});
            this.swiper.slides[index].remove();
            this.swiper.updateSlides();
        }

        if (!is_mobile && index === -1) {
            console.log("addSlide", {index, is_mobile});
            this.swiper.wrapperEl.appendChild(this.$emptySwipe);
            this.swiper.updateSlides();
        }

    }

    onTransitionStart() {
        this.el.classList.add("swiper-transitioning");
    }

    onTransitionEnd() {
        this.el.classList.remove("swiper-transitioning");
    }

    /**
     * Listener for swiper slideChangeTransitionStart event
     *
     * @param swiper
     */
    onSlideTransitionStart(swiper) {

        this.$textOverlay.classList.add("transitioning");
    }

    /**
     * Listener for swiper slideChangeTransitionEnd event
     *
     * @param swiper
     */
    onSlideTransitionEnd(swiper) {
        console.log("onSlideTransitionEnd", swiper);
        // once(this.$textOverlay, "transitionend", (e) => {
            this.updateText(this.$swiperContent[this.swiper.realIndex]);
            this.$textOverlay.classList.remove("transitioning");
        // });
        // this.$textOverlay.classList.add("transitioning");
    }

    /**
     * Updates html content in text overlay
     * @param {HTMLElement} source The source element to read text from
     */
    updateText(source) {
        console.log("updateText", {source});
        this.$textOverlay.innerHTML = source.innerHTML;
    }
}
